import axios from 'axios'
import store from '@/store'
import bus from '@/plugins/bus'
import i18n from '@/plugins/i18n'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
})

instance.interceptors.request.use(config => {
    const token = store.getters['auth/token']
    const tenantCode = store.getters['auth/tenantCode']

    if (token && tenantCode) {
        config.headers['Authorization'] = `Bearer ${token}`
        config.headers['Tenant-Code'] = tenantCode
    }

    config.headers['Accept'] = 'application/json'
    config.headers['Content-Type'] = 'application/json'

    // Precisa que data seja um objeto para enviar o Content-Type
    if (!config.data) {
        config.data = {}
    }

    // config.baseURL = process.env.API_HOST
    config.timeout = process.env.VUE_APP_API_TIMEOUT

    return config
})

instance.interceptors.response.use(
    response => {
        return response
    },

    err => {
        let response = err.response

        if (response.status) {
            if (response.status === 400) {
                if (typeof response.data.errors != 'undefined') {
                    let errors = Object.values(response.data.errors)
                    errors = errors.flat()
                    bus.$emit('notify', 'error', errors.join('<br>'))
                    return
                }

                bus.$emit('notify', 'error', i18n.t('httpErrors.400'))
                //Erro ja foi tratado nao é necessário retornar o reject
                return
            }

            if (response.status === 401) {
                store.dispatch('auth/clear')
                return
            }

            if (response.status === 403) {
                let message = response.data.message
                bus.$emit(
                    'notify',
                    'error',
                    message || i18n.t('httpErrors.403'),
                )
                //Erro ja foi tratado nao é necessário retornar o reject
                return
            }

            if (response.status === 404) {
                if (typeof response.data.errors != 'undefined') {
                    let errors = Object.values(response.data.errors)
                    errors = errors.flat()
                    bus.$emit('notify', 'error', errors.join('<br>'))
                    return
                }

                let message = response.data.message
                bus.$emit(
                    'notify',
                    'error',
                    message || i18n.t('httpErrors.404'),
                )
                //Erro ja foi tratado nao é necessário retornar o reject
                return
            }

            if (response.status === 422) {
                if (typeof response.data.errors != 'undefined') {
                    let errors = Object.values(response.data.errors)
                    errors = errors.flat()
                    bus.$emit('notify', 'warning', errors.join('<br>'))
                    return
                }

                if (typeof response.data.message != 'undefined') {
                    bus.$emit('notify', 'warning', response.data.message)
                    return
                }

                bus.$emit('notify', 'warning', i18n.t('httpErrors.422'))
                return
            }

            if (response.status === 500) {
                bus.$emit('notify', 'error', i18n.t('httpErrors.500'))
                //Erro ja foi tratado nao é necessário retornar o reject
                return
            }
        }

        return Promise.reject(err)
    },
)

export default instance
